module.exports = __webpack_public_path__ + "static/media/info-off.e28df7d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/info-off.svg
// module id = 774
// module chunks = 0